import { CertificateObj } from '../helpers/signer/certificates'
import moment from 'moment'
import { UserRoles } from '@/common/enums/UserRoles'
import { ApplicationStatuses } from '@/common/enums/ApplicationStatuses'
import { OrganizationSubjects } from '@/common/enums/OrganizationSubjects'
import { BaseApiClient } from '@/common/helpers/BaseApiClient'

export default {
  data: () => {
    return {
      externalCertificateInfo: '',
      certInn: '',
      certInnLe: '',
      certSubjectName: '',
      isAwaitingSigning: false
    }
  },

  methods: {
    extractInfoFromCertificate: function (from, what, alternativeWhat = []) {
      let value = new CertificateObj().extract(from, what, alternativeWhat)
      if (value.includes(what)) {
        value = value.replace(what, '')
      } else {
        for (const el of alternativeWhat) {
          if (value.includes(el)) {
            value = value.replace(el, '')
          }
        }
      }
      return value
    },

    async loadExternalInfo (event) {
      if (Number(this.enableStrictCheckCertificate) === 1) {
        this.disableSignButton()
      }
      if (event.target.options.selectedIndex === -1) {
        return
      }

      const cert = this.signer?.certificates[event.target.options.selectedIndex]
      if (cert) {
        this.certInn = this.extractInfoFromCertificate(await cert.SubjectName, 'INN=', ['ИНН=', 'OID 1.2.643.3.131.1.1=', '1.2.643.3.131.1.1='])
        // Атрибут INNLE - ИНН Юридического лица
        this.certInnLe = this.extractInfoFromCertificate(await cert.SubjectName, 'INNLE=', ['ИНН ЮЛ=', 'OID 1.2.643.100.4=', 'oid 1.2.643.100.4=', '1.2.643.100.4='])
        // Атрибут OGRNIP - ОГРНИП
        let OGRNIP = this.extractInfoFromCertificate(await cert.SubjectName, 'OGRNIP=')

        this.certSubjectName = this.extractInfoFromCertificate(await cert.SubjectName, 'SN=') + ' ' +
          this.extractInfoFromCertificate(await cert.SubjectName, 'G=')

        const validTo = moment(await cert.ValidToDate)
          .locale('ru')
          .format('DD.MM.YYYY LT')
        this.externalCertificateInfo =
          'Действителен до: ' + validTo + '<br>' +
          'Издатель: ' + this.extractInfoFromCertificate(await cert.IssuerName, 'O=') + '<br>' +
          'Владелец: ' + this.certSubjectName

        const certValidToDate = new Date(Date.parse(await cert.ValidToDate))
        if (certValidToDate < new Date()) {
          this.externalCertificateInfo += '<br><br><span>Срок действия сертификата истёк</span>'
          return true
        }

        const sbArray = [UserRoles.SB, UserRoles.SB_BLACKLIST, UserRoles.SB_OTHER, UserRoles.SB_TRUCK, UserRoles.SB_SUBDIVISION]
        this.isAwaitingSigning = this.application.status === ApplicationStatuses.AWAITING_SIGNING

        if (Number(this.enableStrictCheckCertificate) === 1 && this.isAwaitingSigning && Number(this.application.require_user_sign) === 1) {
          if (this.application.organization.subject_id === OrganizationSubjects.Entity) {
            // Если «позиция штампа» = «заявитель» И «признак подателя» = 1
            // И «субъект права заявителя» = «ЮЛ», то проверяем соответствие ИНН в секции заявитель полю «ИНН ЮЛ» в подписи
            this.compareCertInn(this.certInnLe, this.organization.inn)
          } else if (this.application.organization.subject_id === OrganizationSubjects.Individual && OGRNIP) {
            // Если «позиция штампа» = «заявитель» И «признак подателя» = 1 И «субъект права заявителя» = «ИП»,
            // то проверяем соответствие ИНН в секции заявитель полю «ИНН» в подписи, а также, чтобы в подписи присутствовало поле «ОГРНИП»
            this.compareCertInn(this.certInn, this.organization.inn)
          } else if (this.application.organization.subject_id === OrganizationSubjects.Fiz) {
            // Если «позиция штампа» = «заявитель» И «признак подателя» = 1 И «субъект права заявителя» = «ФЛ»,
            // то проверяем соответствие ИНН в секции заявитель полю «ИНН» в подписи
            this.compareCertInn(this.certInn, this.organization.inn)
          } else {
            this.compareCertInn(this.certInn, this.organization.inn)
          }

        } else if (this.isAwaitingSigning === false && sbArray.includes(this.user.role) && Number(this.enableStrictCheckCertificateSB) === 1) {
          this.compareCertInn(this.certInnLe, this.application.terminal_organization_inn)
        } else {
          this.enableSignButton()
        }

      }
    },

    async checkMchd (inn) {
      try {
        const response = await BaseApiClient.get(`mchd/check-mchd?inn=${inn}`, {
          headers: BaseApiClient.getAuthHeaders()
        })

        if (response.data && response.data.has_mchd) {
          return true
        }
        return false
      } catch (error) {
        console.error('Error checking MCHD:', error)
        return false
      }
    },

    async checkMchdAvailability (inn) {
      if (!inn) {
        this.externalCertificateInfo += '<br><br><span>Доверенность: не найдена (отсутствует ИНН)</span>'
        return
      }

      try {
        const hasMchd = await this.checkMchd(inn)
        if (hasMchd) {
          this.externalCertificateInfo += '<br><br>Доверенность: найдена'
          this.enableSignButton()
        } else {
          this.externalCertificateInfo += '<br><br><span>Доверенность: не найдена</span>'
        }
      } catch (error) {
        this.externalCertificateInfo += '<br><br><span>Ошибка проверки доверенности</span>'
      }
    },

    compareCertInn (certInn, organizationInn) {
      if (String(certInn) === String(organizationInn)) {
        this.enableSignButton()

        return true
      }
      if (String(certInn) === String(organizationInn)) {
        if (this.isAwaitingSigning) {
          if (this.organization.subject_id === OrganizationSubjects.Individual) {
            if (this.organization.name !== this.certSubjectName) {
              this.externalCertificateInfo += '<br><br><span>Подписант в сертификате не соответствует подписанту в заявке</span>'
            }
            this.externalCertificateInfo += '<br><br>Доверенность: не требуется'
            this.enableSignButton()

            return true
          } else if (this.organization.director_name !== this.certSubjectName) {
            this.externalCertificateInfo += '<br><br><span>Подписант в сертификате не соответствует подписанту в заявке</span>'
            this.checkMchdAvailability(this.organization.inn)
          } else {
            this.externalCertificateInfo += '<br><br>Доверенность: не требуется'
            this.enableSignButton()
          }
        } else {
          this.externalCertificateInfo += '<br><br>Доверенность: не требуется'
          this.enableSignButton()
        }
      } else if (certInn === '') {
        if (this.organization.name.trim().toLowerCase() !== this.certSubjectName.trim().toLowerCase()) {
          this.checkMchdAvailability(this.organization.inn)
        }
      } else {
        if (certInn.length < 12) {
          this.externalCertificateInfo += '<br><br><span>Организация в сертификате не соответствует организации в заявке</span>'
        } else {
          this.checkMchdAvailability(this.organization.inn)
        }
      }
    }
  }
}
